// ============================================================================
// THEME CONFIGURATION — Neurovanta (Earth Synapse Edition)
// AUTO-GENERATED by visual revamp - brand identity: neurovanta
// ============================================================================

const theme = {
  "id": "neurovanta",
  "siteId": "neurovanta",
  "orderPrefix": "NVA",
  "brand": {
    "name": "Neurovanta",
    "short": "Neuro",
    "legalName": "PT NEUROVANTA DIGITAL NUSANTARA"
  },
  "meta": {
    "title": "NeuroVanta | Earth's Digital Synapse Gateway",
    "description": "NeuroVanta — Earth's premier digital synapse gateway for instant game top-ups and digital vouchers. Fully automated, fast transmission, and secure.",
    "themeColor": "#10B981"
  },
  "assets": {
    "heroBg": "", // No messy backgrounds needed for clean SaaS look
    "logo": "/logo-neurovanta.svg"
  },
  "copy": {
    "hero": {
      "titleLine1": "Earth's Unified",
      "titleLine2": "Digital Synapse Gateway",
      "subtitle": "A fully automated, high-speed transaction infrastructure routing game top-ups and digital vouchers instantly. Experience sub-second delivery and optimized rates.",
      "searchPlaceholder": "Search games, products, or vouchers..."
    },
    "features": [
      {
        "label": "Instant Delivery",
        "desc": "Sub-second transaction processing"
      },
      {
        "label": "Optimized Rates",
        "desc": "Automated price balancing for competitive rates"
      },
      {
        "label": "Secure Routing",
        "desc": "End-to-end encrypted transmission paths"
      },
      {
        "label": "24/7 Automated",
        "desc": "Fully automated service active round-the-clock"
      }
    ],
    "cta": {
      "titlePrefix": "Connect with ",
      "titleHighlight": "NeuroVanta",
      "titleSuffix": " Network",
      "subtitle": "Join thousands of users enjoying seamless transaction routing. Fast, automated, and secure digital game top-ups for everyone.",
      "button": "Explore Products"
    },
    "footer": {
      "tagline": "Earth's premier digital synapse gateway. Delivering direct product cataloging, optimized rates, and automated settlement systems globally."
    }
  },
  "colors": {
    "primary": "#10B981", // Emerald
    "secondary": "#06B6D4", // Cyan
    "accent": "#F59E0B", // Amber
    "background": "#09090b", // Zinc 950
    "card": "#18181b", // Zinc 900
    "border": "#27272a", // Zinc 800
    "foreground": "#fafafa", // Zinc 50
    "success": "#10B981",
    "destructive": "#EF4444",
    "gradientFrom": "#10B981",
    "gradientTo": "#06B6D4"
  },
  "fonts": {
    "display": "'Inter', sans-serif",
    "body": "'Inter', sans-serif",
    "mono": "'JetBrains Mono', monospace",
    "googleFontsUrl": "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=JetBrains+Mono:wght@400&display=swap"
  },
  "style": {
    "heroVisual": "earth-synapse", // Let's use our new animated earth synapse visual!
    "mascotGlow": "drop-shadow(0 0 10px rgba(16, 185, 129, 0.2))",
    "heroAccent1": "bg-emerald-500/5",
    "heroAccent2": "bg-cyan-500/5"
  }
};

module.exports = theme;
